/**
 * resolveOrderConfig — читает конфигурацию вопроса типа "order" из данных вопроса/опций.
 *
 *   question.prompts: [{ label }, { label, after_selections }]
 *   options.submit_after_selections: number
 */

import { QuestionData, QuestionOptions, QuestionPrompt } from '@/store/types/testingTypes';

export interface ResolvedOrderConfig {
    /** Промпты (этапы) вопроса в новом формате */
    prompts?: QuestionPrompt[];
    /** После скольких выборов завершить вопрос */
    submitAfterSelections?: number;
}

export const resolveOrderConfig = (
    question?: QuestionData,
    options?: QuestionOptions,
): ResolvedOrderConfig => ({
    prompts: question?.prompts,
    submitAfterSelections: options?.submit_after_selections,
});
